import ACCOUNTING_ACCOUNT_RELATION_TYPES from "./accountingAccountRelationTypes";

const {
  CREATE_ACCOUNTING_ACCOUNT_RELATION,
  DELETE_ACCOUNTING_ACCOUNT_RELATION,
  GET_ACCOUNTS_FOR_RELATION,
  GET_ACCOUNTING_ACCOUNT_RELATION_LIST,
  RESTORE_INITIAL_STATE,
  SET_ACCOUNTING_ACCOUNT_RELATION_SEARCH_FILTERS,
  UPDATE_ACCOUNTING_ACCOUNT_RELATION,
} = ACCOUNTING_ACCOUNT_RELATION_TYPES;

const initialState = {
  accountingAccountList: [],
  accountingAccountRelationList: [],
  station: null,
  hasSearched: false,
};

const extendAccount = (account) => ({
  ...account,
  typeLabel: account.type?.replace(/_+/g, " ") || "",
});

export const accountingAccountRelationReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CREATE_ACCOUNTING_ACCOUNT_RELATION: {
      const belongsToCurrentStation = state.station && payload.idStation === state.station.id;
      return {
        ...state,
        accountingAccountRelationList: belongsToCurrentStation
          ? [...state.accountingAccountRelationList, extendAccount(payload)]
          : state.accountingAccountRelationList,
      };
    }

    case DELETE_ACCOUNTING_ACCOUNT_RELATION: {
      const filteredList = state.accountingAccountRelationList.filter((acc) => acc.id !== payload);
      return {
        ...state,
        accountingAccountRelationList: filteredList,
      };
    }

    case GET_ACCOUNTS_FOR_RELATION: {
      // Respuesta de una planta que ya no está seleccionada (se cambió durante la búsqueda).
      if (payload.stationId !== state.station?.id) return state;
      const extended = payload.list.map((acc) => ({
        ...acc,
        label: `${acc.name} | ${acc.number}`,
      }));
      return {
        ...state,
        accountingAccountList: extended,
      };
    }

    case GET_ACCOUNTING_ACCOUNT_RELATION_LIST:
      if (payload.stationId !== state.station?.id) return state;
      return {
        ...state,
        accountingAccountRelationList: payload.list.map(extendAccount),
        hasSearched: true,
      };

    case SET_ACCOUNTING_ACCOUNT_RELATION_SEARCH_FILTERS:
      return {
        ...state,
        [payload.key]: payload.value,
        ...(payload.key === 'station' && {
          hasSearched: false,
          accountingAccountRelationList: [],
          accountingAccountList: [],
        }),
      };

    case UPDATE_ACCOUNTING_ACCOUNT_RELATION: {
      const updatedList = state.accountingAccountRelationList.map((acc) =>
        acc.id === payload.id ? extendAccount(payload) : acc
      );
      return {
        ...state,
        accountingAccountRelationList: updatedList,
      };
    }

    case RESTORE_INITIAL_STATE:
      return initialState;

    default:
      return state;
  }
};
